/**
 * Bandeau de notification.
 *
 * Sert surtout aux échecs d'écriture : les données partent maintenant sur le
 * réseau, une saisie peut donc échouer silencieusement là où le localStorage
 * n'échouait jamais. Une saisie perdue sans le dire est le pire des deux maux.
 */

import { $ } from './dom.js'

let timer = null

export function toast(message, { error = false, ms = 4000 } = {}) {
  const el = $('toast')
  if (!el) return

  el.textContent = message
  el.classList.toggle('err', error)
  el.classList.add('show')

  clearTimeout(timer)
  timer = setTimeout(() => el.classList.remove('show'), ms)
}

/** Enveloppe une écriture : en cas d'échec, le dit au lieu de le taire dans la console. */
export async function withToast(promise, { failure = 'Enregistrement impossible.' } = {}) {
  try {
    return await promise
  } catch (err) {
    console.error(err)
    toast(`${failure} ${err.message || ''}`.trim(), { error: true })
    return null
  }
}
